
import { Component, Prop } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import CardBody from '@/components/card-body/index.vue'
import Returnlist from '@/entities/returnlist'
import dayjs from 'dayjs'

@Component({
  components: { CardBody }
})
export default class LookupEdit extends AbpBase {
  /**
   * 组件名称
   */
  name: string = 'Returnlist Edit'

  returnlist: Returnlist = new Returnlist()

  workingZoneList: Array<any> = []

  rules = {
    partNo: [
      {
        required: true,
        message: 'Please input Part Number',
        trigger: 'blur'
      }
    ],
    uom: [
      {
        required: true,
        message: 'Please input UOM',
        trigger: 'blur'
      }
    ],
    returnTo: [
      {
        required: true,
        message: 'Please input Return To',
        trigger: 'blur'
      }
    ],
    allowOverdue: [
      {
        required: true,
        message: 'Please select Overdue Allowance',
        trigger: 'change'
      }
    ],
    validityDate: [
      {
        required: true,
        message: 'Please select Validity Date',
        trigger: 'change'
      }
    ]
  }

  // 新建或更新
  doCreateOrUpdate() {
    ;(this.$refs.form as any).validate(async (valid: boolean) => {
      if (!valid) {
        return
      }
       if (this.returnlist.validityDate) {
        this.returnlist.validityDate = dayjs(this.returnlist.validityDate).format(
          'YYYY-MM-DDTHH:mm:ssZ[Z]'
        )
      }
      this.createOrUpdateLookup({
        returnlist: this.returnlist
      })
    })
  }
  // 调用接口
  async createOrUpdateLookup(data) {
    await this.$store.dispatch({
      type: 'returnlist/createOrUpdateReturnlist',
      data: data
    })
     this.$notify.success({
        title: 'Success',
        message: 'Save Success'
      })
    this.doCancel()
  }

  doCancel() {
    ;(this.$refs.form as any).resetFields()
    this.$router.back()
  }

  async getWorkingZoneList() {
    let res = await this.$store.dispatch({
      type: 'workzone/getAllLimit'
    })
    this.workingZoneList = []
    ;(res || []).map(t => {
      if (t.workingZone !== 'ALL' && t.type == 'Warehouse') {
        this.workingZoneList.push({
          label: `${t.workingZone}-${t.name}`,
          value: t.workingZone
        })
      }
    })
  }

  loading = false

  async created() {
    try {
      this.loading = true
      let id = +this.$route.params.id
      await this.getWorkingZoneList()
      if (!id || id < 0) {
        // 新增
        this.$set(this.returnlist, 'isActive', true)
        return
      }
      // 编辑
      this.returnlist.id = +id
      let res = await this.$store.dispatch({
        type: 'returnlist/get',
        id: this.$route.params.id
      })
      this.returnlist = res.returnList
        } catch (e) {
      console.log(e);
    } finally{
      this.loading = false
    }
  }
}
